export interface SummaryConfig {
    summaryGrouping: string;
    totalPrice: boolean;
    disclaimerText: string;
    sendSummaryCard: CardData;
    cards: CardData[];
}

export interface CardData {
    id: string;
    enabled: boolean;
    icon: string;
    title: string;
    description: string;
    buttonText: string;
    feedbackButtonText?: string;
    buttonAction?: string;
    buttonLink?: string;
    isBlueprintLink: boolean;
    sendBlueprintAssortmentIdAs?: { [key: string]: string };
    webshopUrl: string;
    emailSentDescription?: string;
    openInSameTab?: boolean;
    // Form fields for input-collecting cards (SEND_TO_SHOP, SEND_TO_PARENT).
    inputs?: InputData[];
}

export interface InputData {
    id: string;
    title: string;
    required: boolean;
    enabled?: boolean;
}

// Converts JSON strings to/from your types
export class Convert {
    public static toSummaryConfig(json: string): SummaryConfig {
        return JSON.parse(json);
    }

    public static summaryConfigToJson(value: SummaryConfig): string {
        return JSON.stringify(value);
    }
}
